import React, { useState } from 'react'

const ContentExpander = ({ content, startExpanded=false }) => {
  const [showAll, setShowAll] = useState(startExpanded)
  
  let lc = 'line-clamp-3 md:line-clamp-6'
  
  return <div className={`${showAll ? 'line-clamp-none' : lc}`} onClick={() => { setShowAll(!showAll)}}>
    {content}
  </div>
}

export default ContentExpander
